import React, { BaseSyntheticEvent } from 'react';
//
import colors from 'theme/colors';

interface Props {
  fill: string;
  size?: number;
  onClick?: (e: BaseSyntheticEvent) => void;
}

const plotSize = 30;

const CompareTabIcon = ({ fill = colors.globalIcon, size = plotSize, onClick }: Props) => (
  <svg width={size} height={size} viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
    <rect x="0.5" y="0.5" width="19" height="15" rx="1.5" stroke={fill} />
    <rect x="2.97388" y="3" width="4" height="10" rx="1" fill={fill} />
    <rect x="7.97388" y="3" width="4" height="10" rx="1" fill={fill} />
    <rect x="12.9739" y="3" width="4" height="10" rx="1" fill={fill} />
  </svg>
);

export default CompareTabIcon;
